<div class="chart-container card flex space-around">
    <p-toast position="bottom-center" key="bc"/>
    <p-button id="exportButton" (click)="exportChart()" icon="pi pi-download" pTooltip="Export Chart" tooltipPosition="top"></p-button>
    <p-chart #chart type="bar" [data]="chartResults" [options]="chartOptions">
    </p-chart>
    <p-treeTable id="source" [value]="treeTableResults" [scrollable]="true" *ngIf="!showDetail">
        <ng-template pTemplate="header">
            <tr>
                <th *ngFor="let col of tableColumns" [ngStyle]="{',om': col.width + 'px'}" [ngClass]="{
                    'align-right': col.align === 'right'
                }">
                    {{ col.label }}
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowNode let-rowData="rowData">
            <tr [ttRow]="rowNode">
                <td *ngFor="let col of tableColumns; let index = index" [ngStyle]="{'min-width': col.width + 'px'}"
                [ngClass]="{'object-attribute': col.field === 'attribute' && rowNode.parent !== null,
                    'object-source': col.field === 'srcmatch' && rowNode.parent !== null,
                    'align-right': col.align === 'right'
                 }"
                (click)="showDetailedTable(col.field, rowNode)">
                    <p-treeTableToggler [rowNode]="rowNode" *ngIf="index == 0"></p-treeTableToggler>
                    <ng-container *ngIf="isNumber(rowData[col.field]); else notNumber">
                        {{ rowData[col.field] | number }}
                    </ng-container>
                    <ng-template #notNumber>
                        {{ rowData[col.field] == 0 ? "" : rowData[col.field] }}
                    </ng-template>
                </td>
            </tr>
        </ng-template>
    </p-treeTable>
    <button pButton id="backButton" *ngIf="showDetail" (click)="backToSummary()">Back to Summary</button>
    <app-detail-table style="display:block;width:100%;"*ngIf="showDetail" [data]="detailTableData"></app-detail-table>
</div>